export const OPERATORS_DATE = [
    { value: '=', label: 'Is Equal to' },
    { value: '!=', label: 'Is NOT Equal to' },
    { value: 'is null', label: 'Is Blank' },
    { value: 'is not null', label: 'Is Not Blank' },
    { value: '<', label: 'Is earlier than' },
    { value: '<=', label: 'Is earlier than or equal to' },
    { value: '>', label: 'Is later than' },
    { value: '>=', label: 'Is later than or equal to' },
    { value: 'this_week', label: 'This Week', ignoring_year: true },
    { value: 'last_week', label: 'Last Week', ignoring_year: true },
    { value: 'this_month', label: 'This Month', ignoring_year: true },
    { value: 'last_month', label: 'Last Month', ignoring_year: true },
    { value: 'last_n_days', label: 'In the last n Days', ignoring_year: true },
    { value: 'not_last_n_days', label: 'Not in the last n Days', ignoring_year: true },
    { value: 'today', label: 'Today', ignoring_year: true },
    { value: 'next_month', label: 'Next Month', ignoring_year: true },
    { value: 'last_n_months', label: 'Last n Months', ignoring_year: true },
    { value: 'next_n_months', label: 'Next n Months', ignoring_year: true },
    { value: 'not_last_n_months', label: 'Not in the last n Months', ignoring_year: true },
    { value: 'next_week', label: 'Next Week', ignoring_year: true },
    { value: 'next_n_days', label: 'Next n Days', ignoring_year: true },
    { value: 'n_days_from_now', label: 'Exactly n days from now', ignoring_year: true },
    { value: 'n_days_ago', label: 'Exactly n days ago', ignoring_year: true },
];

export const OPERATORS_N = [
    'last_n_days_ignoring_year',
    'last_n_days',
    'last_n_months_ignoring_year',
    'last_n_months',
    'n_days_ago_ignoring_year',
    'n_days_ago',
    'n_days_from_now_ignoring_year',
    'n_days_from_now',
    'next_n_days_ignoring_year',
    'next_n_days',
    'next_n_months_ignoring_year',
    'next_n_months',
    'not_last_n_days_ignoring_year',
    'not_last_n_days',
    'not_last_n_months_ignoring_year',
    'not_last_n_months',
];

export const OPERATORS_THAT_DONT_NEED_VALUE = [
    'is null',
    'is not null',
    '= 1',
    '= 0',
    'this_week',
    'last_week',
    'this_month',
    'last_month',
    'today',
    'next_week',
    'next_month',
    'this_week_ignoring_year',
    'last_week_ignoring_year',
    'this_month_ignoring_year',
    'last_month_ignoring_year',
    'today_ignoring_year',
    'next_week_ignoring_year',
    'next_month_ignoring_year',
];

export const PROFILE_ATTRIBUTES = [
    'contacts.email',
    'contacts.entry_channel',
    'contacts.membership_status',
    'contacts.lifecycle_status',
    'contacts.custom_attributes.key',
    'contacts.custom_attributes.value',
    'contacts.custom_attributes.exclude',
    'contacts.custom_attributes.created_at',
    'contacts.custom_attributes.updated_at',
    'contacts.custom_attributes.key_value',
    'contacts.custom_attributes.exclude_key_value',
];

export const makeId = () => {
    return -1 * Math.floor(Math.random() * 999999);
};

export const makeFilter = () => {
    return {
        id: makeId(),
        attribute_name: null,
        data_type: null,
        key: null,
        operator: null,
        profile: null,
        value: null,
    };
};

export const makeGroup = () => {
    return {
        id: makeId(),
        filters: [makeFilter()],
    };
};
